import React from 'react';

class AddressLabel extends React.Component {
  render() {
    const { address } = this.props;
    return (
      <div className="address-label">
        <div className="row row--space-between">
          <div className="row__item">
            {address.label ? (
              <div className="p address-label__tag">{address.label}</div>
            ) : (
              ''
            )}
          </div>
          <div className="row__item">
            {address.default ? (
              <p className="p address-label__default">Default</p>
            ) : (
              ''
            )}
          </div>
        </div>

        <div className="p">{address.street_address}</div>
        <div className="p">{address.street_address_continued}</div>
        <div className="p">
          {address.city}, {address.state} {address.zip_code}
        </div>
      </div>
    );
  }
}
export default AddressLabel;



// WEBPACK FOOTER //
// ./src/components/shared/AddressLabel.js